module.exports = __webpack_public_path__ + "assets/img/t22.403514cb.png";